export const SERVER_ID_THRESHOLD = 1000000000
export const WEEKDAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]
export const DEFAULT_TIMEZONE = "America/Los_Angeles"
export const DEFAULT_COUNTRY_CODE = "US"
export const AVAILABILITY_TYPES = {
  ALL_YEAR: "all_year",
  SEASONAL: "seasonal"
}
export const INITIAL_FORM_DATA = {
  avatar: null,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  phoneCountryCode: DEFAULT_COUNTRY_CODE,
  title: "",
  permissionRole: "",
  description: "",
  availability: AVAILABILITY_TYPES.ALL_YEAR,
  experiences: []
}

export const createInitialSeason = () => ({
  id: Date.now(),
  from: null,
  to: null,
  recurringYearly: false,
  selectedDays: [],
  _destroy: false
})

export const isServerGeneratedId = (id) => {
  return id && typeof id === "number" && id < SERVER_ID_THRESHOLD
}
